// Copyright © 2021 Move Closer

import { Color } from '../../_contracts'

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export enum NewsBarColor {
  Black = Color.Black,
  Blue = Color.Blue,
  Brand = Color.Brand,
  Gray = Color.Gray,
  Green = Color.Green,
  Custom = Color.Custom
}

/**
 * @author Sebastian Dziechciarz, Stanisław Gregor
 */
export type NewsBarConfig = Record<NewsBarColor, NewsBarThemeSettings>

/**
 * @author Sebastian Dziechciarz, Stanisław Gregor
 */
export interface NewsBarThemeSettings {
  /**
   * The CSS class that contains the style declarations for the background of the `<NewsBar>`.
   */
  bgClass: string;

  /**
   * The CSS class that contains the style declarations for the text elements inside the `<NewsBar>`.
   */
  textClass: string;
}

/**
 * This enum is needed for better TypeScript experience
 * within the `NewsBar.stories.ts` file.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 *
 * @see ./NewsBar.stories.ts
 */
export enum NewsBarPropNames {
  Closable = 'closable',
  Color = 'color',
}
